<template>
  <div class="container">
    <div class="main">
      <big-map ref="bigmap"
               code="new_pipe_network_legend" />
    </div>
  </div>
</template>
<script>
import HeaderLayout from '@/layouts/HeaderLayout.vue'
import BigMap from './../components/MobileBigMap.vue'
export default {
  components: {
    [BigMap.name]: BigMap,
    HeaderLayout
  },
  watch: {},
  data () {
    return {
      map: null,
      openyxcxTable: false,
      openQueryTable: false,
      opensscxTable: false,
      opendlcsTable: false,
      diameter: '',
      material: '',
      sscxInputData: null,
      radioGroupValue: 1,
      cqlString: ''
    }
  },
  filters: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .main {
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
}
</style>
